$(document).ready(function () {
  $('.tooltip > span').hover(
    function () {
      $(this).next('.tooltip_text').fadeIn()
    },
    function () {
      $(this).next('.tooltip_text').fadeOut()
    }
  )
})
